import type { ComponentType } from "react";
import type { PermissionEvaluator } from "../../permissions";
import type { AppFeatureDefinition } from "../contracts";
import type { ServiceContainer } from "../contracts";
import { resolveVisibleFeatures } from "./resolveFeatureNavigation";

export interface ResolvedShellSlot {
  readonly featureId: string;
  readonly topBarEnd: ComponentType;
}

/**
 * Slots ride the same requiredPermissions gate as the rest of the feature —
 * a user who cannot see a module's routes doesn't get its top-bar chrome
 * either.
 */
export function resolveFeatureShellSlots(
  modules: readonly AppFeatureDefinition[],
  permissions: PermissionEvaluator,
  services: ServiceContainer,
): readonly ResolvedShellSlot[] {
  return resolveVisibleFeatures(modules, permissions)
    .map((module) => {
      const slots = module.shellSlots?.(services);
      return slots?.topBarEnd === undefined
        ? undefined
        : { featureId: module.id, topBarEnd: slots.topBarEnd };
    })
    .filter((slot): slot is ResolvedShellSlot => slot !== undefined);
}
